(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-alerts"]) return;
  try {
    
$.each($("#product-alerts .alert"), function(){
  $("#" + this.id).detach().appendTo($(this).data("location"))
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sbo-products"]) return;
  try {
    
  $("#load-trip-imgs").on("click tap", function(){
    $(".trip-img").removeClass("hidden");
    $(this).hide();
  });

  } catch(e) { console.error(e); }
})();
})();
